/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S8_Li1_BeforeInputs */

const tr_onbilgi_s8_li1_before = /** @type {(inputs: Onbilgi_S8_Li1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const en_onbilgi_s8_li1_before = /** @type {(inputs: Onbilgi_S8_Li1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a written notice to `)
};

const de_onbilgi_s8_li1_before = /** @type {(inputs: Onbilgi_S8_Li1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine schriftliche Mitteilung an `)
};

const ru_onbilgi_s8_li1_before = /** @type {(inputs: Onbilgi_S8_Li1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Направить письменное уведомление на адрес `)
};

/**
* | output |
* | --- |
* | "Send a written notice to" |
*
* @param {Onbilgi_S8_Li1_BeforeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s8_li1_before = /** @type {((inputs?: Onbilgi_S8_Li1_BeforeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S8_Li1_BeforeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s8_li1_before(inputs)
	if (locale === "de") return de_onbilgi_s8_li1_before(inputs)
	if (locale === "ru") return ru_onbilgi_s8_li1_before(inputs)
	return tr_onbilgi_s8_li1_before(inputs)
});